module.exports = __webpack_public_path__ + "img/h7.c8f36b75.png";